import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[crmTgbotSideNavDropdownPanel]',
})
export class SideNavDropdownPanelDirective {
  tpl = inject(TemplateRef<unknown>);
}
